import clsx from "clsx";

export interface Tab {
  label: string;
  value: string;
}

export interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange?: (value: string) => void;
  className?: string;
}

export const Tabs = ({ tabs, activeTab, onTabChange, className }: TabsProps) => {
  const Tag = onTabChange ? "button" : "span";
  const isSpan = Tag === "span";

  return (
    <div className={clsx("flex flex-wrap gap-6", isSpan && "items-center", className)}>
      {tabs.map((tab) => {
        const isActive = tab.value === activeTab;

        return (
          <Tag
            key={tab.value}
            type="button"
            onClick={onTabChange ? () => onTabChange(tab.value) : undefined}
            className={clsx(
              isActive ? "border-b-3 border-primary text-primary font-medium py-2" : "pb-1 font-normal",
              isActive && isSpan && "leading-5",
            )}
          >
            {tab.label}
          </Tag>
        );
      })}
    </div>
  );
};
